module.exports = __webpack_public_path__ + "img/typeCourseFooter.77d4243c.png";